import { Fragment, useEffect, useState } from "react";
import { useHistory, Route } from "react-router-dom"
//---------------------------------------------------------------------
import UserInfo from "src/components/common/userInfo";
import TransitionWidthHeight from "src/components/common/TransitionWidthHeight";
import Resize from "src/components/common/resize";
import magnifierImg from "src/img/magnifier.png";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import { isDevMode, myAxios, MyFormData, scroll, boolAndReducer, getTimeStamp } from "src/components/common/functions";
import Detail from "./detail";
import CommunityForm from "./communityForm";
//---------------------------------------------------------------------
export default function Community(){
    //--------------------------------------------------------------------------------------------
    // if(isDevMode) console.log("all");
    //--------------------------------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    // const allCommunities = useMyStore(state => state.comunities);
    // const setCommunities = useMyStore(state => state.setCoummnities);
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    const path = history.location.pathname;
    const path1 = decodeURIComponent(path.split("/")[1] ?? ""); // title
    const path2 = decodeURIComponent(path.split("/")[2] ?? ""); // hash | "Add"
    const path3 = decodeURIComponent(path.split("/")[3] ?? ""); // "Edit"
    //--------------------------------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState(getTimeStamp());
    const [showLoading, setShowLoading] = useState(true);
    const [rawData, setRawData] = useState([]); // main data, can be centeralize
    const [filterWords, setFilterWords] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    //--------------------------------------------------------------------------------------------
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filteredCommunities = rawData.filter(u => (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true)) 
    );
    const currentPageCummunities = filteredCommunities.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filteredCommunities.length / itemsPerPage)}, (_, i) => (i + 1));
    //---------------------------------------------------------------------
    const closeIt = () => {
        path3?
        history.push(`/${path1}/${path2}`)
        :
        history.push(`/${path1}`)
    }
    //---------------------------------------------------------------------
    useEffect(() => {
        if(isDevMode) console.log("useEffect");
        let isMounted = true;
        const controller = new AbortController();
        const getData = async () => {
            //--------------------------------------------------------
            setShowLoading(true);
            const res = await myAxios("community/readCommunity.php", undefined, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //--------------------------------------------------------
            const distinctiveData = res.data.filter(d => !d.parentHashKey).map(d => ({...d, reply: res.data.filter(dd => d.communityHashKey === dd.parentHashKey)}));
            setRawData(distinctiveData);
            if(!distinctiveData.find(u => path2 === u.communityHashKey)){
                switch(path2){
                    case "Add":
                        return;
                    case undefined:
                        return
                    default:
                }
                history.replace(`/${path1}`);
                return;
            }
        }
        getData();
        return () => {
            isMounted = false;
            controller.abort();
            setShowLoader(false);
        }
    }, [updateDateTime, setShowLoader, history, path1, path2])
    useEffect(() => {
        if(path2 !== "" && path2 !== "Add"){
            const hashkeys = filteredCommunities.map(v => v.communityHashKey);
            setCurrentPage(Math.ceil((hashkeys.indexOf(path2) + 1) / itemsPerPage));
            scroll(path2);
        }
    }, [path2, itemsPerPage, filteredCommunities])
    //---------------------------------------------------------------------
    return (
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {path1}
                    <span data-toggle = "tooltip" title = {"Refreshed on " + updateDateTime} className = "btn btn-primary py-1 ml-4" onClick = {() => setUpdateDateTime(getTimeStamp())}>↻</span>
                </span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <span className = "pointer" onClick = {() => history.push(`/${path1}/Add`)}>Add</span>
                <Route path = {`/${path1}/Add`} children = {
                    <CommunityForm
                        keyword = "Add"
                        handleSubmit = {async e => {
                            e.preventDefault();
                            const formData = new MyFormData(e.currentTarget);
                            //---------------------------------------------------------------------
                            setShowLoader(true);
                            const res = await myAxios("community/createCommunity.php", formData);
                            setShowLoader(false);
                            if(!res) return;
                            //---------------------------------------------------------------------
                            const distinctiveData = res.data.filter(d => !d.parentHashKey).map(d => ({...d, reply: res.data.filter(dd => d.communityHashKey === dd.parentHashKey)}));
                            setRawData(distinctiveData);
                            
                            closeIt();
                        }}
                        closeIt = {closeIt}
                    />
                }/>
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !filteredCommunities.length?<div className = "cssLoading">Empty</div>:
                <div className = "overflow-visible">
                    <table className = "table">
                        <thead>
                            <tr className = "stickyHeader">
                                <th></th>
                                <th className = "text-left">User Name</th>                    
                                <th className = "text-left">Subject</th>
                                <th className = "text-left">Date Created</th>
                                <th className = "text-left">Date Updated</th>
                            </tr>
                            </thead>
                            <tbody> 
                            {currentPageCummunities.map((r, key) =>
                                <Fragment key = {key}>
                                <tr
                                    id = {r.communityHashKey}
                                    className = "pointer"
                                    onClick = {async e => {
                                        if(!e.target.id){
                                            if(path2 !== e.currentTarget.id){
                                                history.push(`/${path1}/${e.currentTarget.id}`);
                                                scroll(e.currentTarget.id);
                                            }else{
                                                history.push(`/${path1}`);
                                                scroll(null);
                                            }
                                        }
                                    }}
                                >
                                    <td className = {path2 === r.communityHashKey?"showMinus":"showPlus"}></td>
                                    <td>
                                    <UserInfo 
                                        name = {r.userName}
                                        email = {r.email}
                                    />
                                    </td>
                                    <td className = "font-weight-bold h5">
                                        {r.subject}
                                    </td>
                                    <td>
                                        {r.dateCreated}
                                    </td>
                                    <td>
                                        {r.dateUpdated === r.dateCreated?"":r.dateUpdated}
                                    </td>
                                </tr>
                                <tr>
                                <td className = "noborder" colSpan = {100}>
                                <TransitionWidthHeight 
                                    classNames = "cssTDTransition"
                                    In = {path2 === r.communityHashKey}
                                >
                                    <Detail
                                        closeIt = {closeIt}
                                        path1 = {path1}
                                        path2 = {path2}
                                        community = {r}
                                        history = {history}
                                        setRawData = {setRawData}
                                        deleteUser = {async e => {
                                            if(!window.confirm("Are you sure to delete this post?")) return;
                                            const formData = new MyFormData();
                                            formData.append("communityHashKey", e.currentTarget.id);
                                            formData.append("picArrayId", e.currentTarget.getAttribute("picid"));
                                            //---------------------------------------------------------------------
                                            setShowLoader(true);
                                            const res = await myAxios("community/deleteCommunity.php", formData);
                                            setShowLoader(false);
                                            if(!res) return;
                                            //---------------------------------------------------------------------
                                            const distinctiveData = res.data.filter(d => !d.parentHashKey).map(d => ({...d, reply: res.data.filter(dd => d.communityHashKey === dd.parentHashKey)}));
                                            setRawData(distinctiveData);
                                            closeIt();
                                        }}
                                        editUser = {async e => {
                                            e.preventDefault();
                                            const formData = new MyFormData(e.currentTarget);
                                            //---------------------------------------------------------------------
                                            setShowLoader(true);
                                            const res = await myAxios("community/updateCommunity.php", formData);
                                            setShowLoader(false);
                                            if(!res) return;
                                            //---------------------------------------------------------------------
                                            const distinctiveData = res.data.filter(d => !d.parentHashKey).map(d => ({...d, reply: res.data.filter(dd => d.communityHashKey === dd.parentHashKey)}));
                                            setRawData(distinctiveData);
                                            closeIt();
                                        }}
                                    />
                                    </TransitionWidthHeight>
                                </td>
                            </tr>
                            </Fragment>)}
                        </tbody>
                    </table>
                </div>}
                {!showLoading && filteredCommunities.length?
                <Footer
                    length = {filteredCommunities.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}

                    paginateAction = {() => history.push(`/${path1}`)}
                />
                :null}
            </div>
        </div>
    )
}